import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import HomeTwo from './views/HomeTwo.vue';
import HomeThree from './views/HomeThree.vue';
import PartTwo from './views/PartTwo/PartTwo.vue';
import PartThree from './views/PartThree/PartThree.vue';
import PartThreeMore from './views/PartThree/PartThreeMore.vue';
import PartFour from './views/PartFour/PartFour.vue';
import PartFive from './views/PartFive/PartFive.vue';
import PartFiveMoreOne from './views/PartFive/MoreOne.vue';
import PartFiveMoreTwo from './views/PartFive/MoreTwo.vue';
import PartFiveMoreThree from './views/PartFive/MoreThree.vue';
import PartSix from './views/PartSix/PartSix.vue';
import PartSeven from './views/PartSeven/PartSeven.vue';
import Download from './views/Download/Download.vue';

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/main',
    },
    {
      path: '/main',
      name: 'home',
      component: Home,
      meta: {
        index: 1,
      },
    },
    {
      path: '/home2',
      name: 'home2',
      component: HomeTwo,
      meta: {
        index: 2,
      },
    },
    {
      path: '/home3',
      name: 'home3',
      component: HomeThree,
      meta: {
        index: 3,
      },
    },
    {
      path: '/part2',
      name: 'part2',
      component: PartTwo,
      meta: {
        index: 4,
      },
    },
    {
      path: '/part3',
      name: 'part3',
      component: PartThree,
      meta: {
        index: 5,
      },
    },
    {
      path: '/part3-1',
      name: 'part3-1',
      component: PartThreeMore,
      meta: {
        index: 6,
      },
    },
    {
      path: '/part4',
      name: 'part4',
      component: PartFour,
      meta: {
        index: 7,
      },
    },
    {
      path: '/part5',
      name: 'part5',
      component: PartFive,
      meta: {
        index: 8,
      },
    },
    {
      path: '/part5-1',
      name: 'part5-1',
      component: PartFiveMoreOne,
      meta: {
        index: 9,
      },
    },
    {
      path: '/part5-2',
      name: 'part5-2',
      component: PartFiveMoreTwo,
      meta: {
        index: 10,
      },
    },
    {
      path: '/part5-3',
      name: 'part5-3',
      component: PartFiveMoreThree,
      meta: {
        index: 11,
      },
    },
    {
      path: '/part6',
      name: 'part6',
      component: PartSix,
      meta: {
        index: 12,
        keepAlive: false,
      },
    },
    // {
    //   path: '/part7',
    //   name: 'part7',
    //   component: PartSeven,
    //   meta: {
    //     index: 13,
    //   },
    // },
    {
      path: '/download',
      name: 'download',
      component: Download,
      meta: {
        index: 0,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.index < from.meta.index) {
    // 后退
    to.meta.keepAlive = true;
  } else {
    // 前进
    to.meta.keepAlive = false;
  }
  next();
});

export default router;
